'use client';
import { FC, useState } from 'react';

interface Props {
    text: string;
    onClick: () => void;
}

const UnderlinedButton: FC<Props> = ({ text, onClick }) => {
    const [active, setActive] = useState(false);
    return (
        <div
            className="tw-cursor-pointer"
            onClick={onClick}
            onMouseEnter={() => setActive(true)}
            onMouseLeave={() => setActive(false)}
        >
            <span className="tw-uppercase tw-text-[#ce0058] tw-font-gotham-bold tw-text-[13px]">
                {text}
            </span>
            <div
                className={` tw-h-[2px] tw-bg-[#ce0058] ${active ? 'tw-w-full' : 'tw-w-0'} tw-transition-all tw-duration-500`}
            ></div>
        </div>
    );
};

export default UnderlinedButton;
